import type { SubmissionSchemaFragment } from 'bundles/programming-common/api/__generated__/ProgrammingAssignmentQuery';

export type ProgrammingSubmissionSchemaTypename = Required<SubmissionSchemaFragment['submissionSchema']>['__typename'];

export const ProgrammingSubmissionSchemaTypeNames: Record<string, ProgrammingSubmissionSchemaTypename> = {
  WEB: 'Programming_WebSubmissionSchema',
  SCRIPT: 'Programming_ScriptSubmissionSchema',
  LAB: 'Programming_LabSubmissionSchema',
};
